import React from 'react';
import { ServerNotification } from '../../../../types/serverNotifications/serverNotificationTypes';
import Icon from '../../../../muiComponents/Icon';
import ResolveNotificationCheckbox from './ResolveNotificationCheckbox';
import { ZITONEO_HOTEL_ENTITY_TYPE } from '../../../../utils/serverNotifications/serverNotificationsUtils';
import useTranslate from '../../../../customHooks/useTranslate';
import Button from '../../../../muiComponents/Button';
import { commonIcons } from '../../../../utils/commonVariables/commonIcons';
import { useNotificationHotel } from './useNotificationHotel';

interface NotificationItemProps {
    notification: ServerNotification;
    onNavigate: () => void;
}

/**
 * Displays a server notification with its status icon and description.
 * @param props.notification The notification to display.
 * @returns The notification content.
 */
const NotificationItem = ({
    notification,
    onNavigate,
}: NotificationItemProps) => {
    const translate = useTranslate();
    const { handleGoToHotel } = useNotificationHotel(
        notification.idEntity,
        onNavigate
    );
    const isHotelNotification =
        notification.entityName === ZITONEO_HOTEL_ENTITY_TYPE;

    return (
        <div className='server-notifications__item'>
            <div
                className='server-notification__icon-container'
                style={{
                    color: notification.statusColor,
                    backgroundColor: notification.statusBackgroundColor,
                }}
            >
                <Icon iconName={notification.alertTypeIcon} />
            </div>
            <div className='server-notifications__content'>
                <p className='server-notifications__name'>
                    {notification.alertType}
                </p>
                <p className='server-notifications__description'>
                    {notification.description}
                </p>
                {isHotelNotification && (
                    <div className='flex'>
                        <Button
                            size='small'
                            onClick={handleGoToHotel}
                            aria-label={translate('go_to_hotel')}
                            startIcon={commonIcons.NEW_WINDOW}
                        >
                            {translate('go_to_hotel')}
                        </Button>
                    </div>
                )}
            </div>
            <ResolveNotificationCheckbox notification={notification} />
        </div>
    );
};

export default NotificationItem;
